export const selector = '.c-featured-content__card[data-content-type="Events"][data-url]';

// To prevent double reinitialising
const initialisedItems = new WeakSet();

export class FeaturedItemEvent {
  constructor($el) {
    const handleClick = e => {
      if (!e.target.closest('a')) {
        e.preventDefault();
        document.location = $el.dataset.url;
      }
    };

    if (!initialisedItems.has($el)) {
      $el.addEventListener('click', handleClick);
      initialisedItems.add($el);
    }
  }
}

document.querySelectorAll(selector).forEach($el => new FeaturedItemEvent($el));
